// extracted by mini-css-extract-plugin
module.exports = {"chatDialog":"ChatDialog_chatDialog__sBDu2"};